/**
 * 🧪 DASHBOARD PREVIEW PAGE (for testing)
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Página de prueba para visualizar dashboards mock sin backend.
 * Útil para desarrollo y validación visual del sistema.
 */

import React, { useState } from 'react';
import '../../../pages/DashboardPage.css';
import { DashboardGrid } from '../components/DashboardGrid';
import { mockTimeTrackingDashboard, mockSalesDashboard } from '../../../utils/mockDashboardData';
import type { Dashboard } from '../../../types/dashboard';

export const DashboardPreview: React.FC = () => {
  const [selectedDashboard, setSelectedDashboard] = useState<Dashboard>(mockTimeTrackingDashboard);
  
  const dashboards = [
    { id: 'time_tracking', name: 'Time Tracking', data: mockTimeTrackingDashboard },
    { id: 'sales', name: 'Ventas', data: mockSalesDashboard }
  ];
  
  return (
    <div className="dashboard-page">
      
      {/* Header con selector */}
      <div className="dashboard-header">
        <div className="dashboard-header-content">
          <h1 className="dashboard-title">
            {selectedDashboard.title}
          </h1>
          
          {selectedDashboard.description && (
            <p className="dashboard-description">
              {selectedDashboard.description}
            </p>
          )}
          
          {selectedDashboard.heroInsight && (
            <div style={{ marginTop: '12px', display: 'flex', gap: '12px', alignItems: 'center' }}>
              <span className={`confidence-badge confidence-${selectedDashboard.heroInsight.confidence}`}>
                Confianza: {selectedDashboard.heroInsight.confidence}
              </span>
              <span style={{ fontSize: '12px', color: '#64748b' }}>
                Generado por: {selectedDashboard.heroInsight.generatedBy}
              </span>
            </div>
          )}
        </div>
        
        {/* Selector de dashboard */}
        <div style={{ display: 'flex', gap: '8px' }}>
          {dashboards.map(dash => (
            <button
              key={dash.id}
              onClick={() => setSelectedDashboard(dash.data)}
              className="action-button"
              style={{
                background: selectedDashboard.id === dash.data.id ? '#0ea5e9' : '#334155',
                borderColor: selectedDashboard.id === dash.data.id ? '#0ea5e9' : '#475569'
              }}
            >
              {dash.name}
            </button>
          ))}
        </div>
      </div>
      
      {/* Grid con widgets */}
      <DashboardGrid dashboard={selectedDashboard} />
      
    </div>
  );
};

export default DashboardPreview;
